<template>
    <div class="right author-right">
        <div class="chapter-title flexible aItem-center jc-between">
            <div class="page-title font-MT ">
                <img class="fh-img" src="@/assets/ic_fh.png" alt="" @click="goBack()">
                <span class="f22 page-name text-333 fwb-600">{{ bookdetail.iname }}</span>
            </div>
        </div>
        <div class="chapter-list" >
            <div class="list-title flexible jc-between aItem-center">
                <div class="title f16 text-333 fwb-500 flex">章节列表<span class="ml5 f12 text-danger">(短篇默认前4章免费，中篇默认前8章免费。如需修改，请联系编辑。)</span></div>
                <router-link :to="`/author/authorManage/newChapter/${bookdetail.id}/0`">
                    <div class="btn-default">新建章节</div>
                </router-link>
            </div>
            <div class="list-content">
                <div v-for="(item,index) in chapterList" class="flexible" @click="goDetail(item)">
                    <img v-if="!item.free" class="vip-img" src="@/assets/author/ic_vip.png" >
                    <div class="name-num f16 text-666">{{ index + 1<=9?`0${index + 1}`:index + 1}}</div>
                    <div class="name f16 text-666">{{ item.iname }}</div>

                    <div  :style="{color: item.inspectStatus == 2 ?'#0E9A00': item.inspectStatus == -2 ?'#FF4646':'#666'}" class=" f14 ">{{item.inspectStatus == 0?'待提交审核':item.inspectStatus == 1?'审核中':item.inspectStatus == 2?'审核通过 ':item.inspectStatus == -2?'审核驳回':''}}</div>

                    <div class="flexible" v-if="item.inspectStatus == 2 && !item.open" >
                        <span class="f14" :style="{color: item.open ?'#0E9A00':'#FF4646'}" style="padding:0 3px;">|</span>
                        <span class="f14" :style="{color: item.open ?'#0E9A00':'#FF4646'}">  {{'未公开'}}</span>
                    </div>
                    <div class="flex text-hidden">
                        <div class="status f16" v-if="item.inspectStatus == -2">{{ item.comment }}</div>
                    </div>
                    <div class="flexible jc-between-end">
                        <div class="words f16">{{ item.words }} 字</div>
                        <div class="time f16">{{ item.updateTime }}</div>
                        <span class="delete-btn f14" @click.stop="delChapterFun(item)"><i class="el-icon-delete"></i></span>
                    </div>
                </div>
            </div>
            <div class="datanull" v-if="!chapterList || (chapterList && chapterList.length == 0)">
                <img src="@/assets/author/no-data.png" />
                <p>暂无章节列表</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getchapterlistApi,
        delChapterApi
        // getNormalInfo
    } from "apiurl/author";
    export default {
        props: {
            bookdetail: Object
        },
        watch: {
            bookdetail(n) {
            },
        },
        data() {
            return {
                chapterList: [],
                ispopshow: false,
            }
        },
        mounted() {
            console.log(this.bookdetail)
            this.getChapterList()
        },
        methods: {
            goBack(){
                this.$router.push(`/author`);
            },
            goDetail(item) {
                console.log(item)
                console.log(this.bookdetail)
                this.$store.dispatch('setAInfo',this.bookdetail)
                this.$store.dispatch('setChapterInfo',item)
                this.$router.push(
                    `/author/authorManage/newChapter/${this.$route.params.id}/${item.id}`)
                // this.$router.push(
                //         `/author/authorManage/chapterList/newChapter/${this.$route.params.id}/${item.id}/${this.bookdetail.allowPrice}`)
            },
            getChapterList() {
                getchapterlistApi(this.$route.params.id).then(res => {
                    if (res.success) {
                        this.chapterList =  res.data;
                    }
                })
            },
            delChapterFun(row){
                console.log(row)
                if(this.bookdetail.sign&&row.open){
                    this.$faild('custom','作品签约并且章节公开不能删除！！！')
                    return false;
                }
                this.$confirm('确定删除吗？', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delChapterApi({chapterId:row.id}).then(res=>{
                        console.log(res)
                        if(res.code==1){
                            this.$success('del')
                            this.$emit('changeChapter', '')
                            this.getChapterList()
                        }
                    })
                })
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";

    .right {
        padding: 0 !important;

        .chapter-title {
            padding: 40px !important;
        }

        .chapter-list {
            .list-content {
                padding: 10px 0;

                &>div {
                    height: 60px;
                    line-height: 60px;

                    padding: 0 40px;
                    position: relative;
                    .vip-img{
                        position: absolute;
                        left: 14px;
                        top: 20px;
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                    }
                    // border: 1px solid #FE4848;
                    .name-num {
                        margin-right: 30px
                    }

                    .name {
                        margin-right: 30px
                    }

                    .status {
                        color: #FF4646;
                    }

                    .words {
                        color: #BABABA;
                        margin-right: 20px
                    }

                    .time {
                        color: #BABABA;
                        margin-right: 20px
                    }
                    .delete-btn{
                        color: #BABABA;
                        font-size: 16px;
                    }
                    .pos-right {
                        position: absolute;
                        right: 40px;
                        top: 0;
                    }
                }

                &>div:hover {
                    background: #F5F5F5;
                    .delete-btn{
                        color:#f68a01;
                    }
                }
            }
        }

        .list-title {
            padding: 0 40px;
            border-bottom: 1px solid #F2F2F2;
            .title {
                padding-bottom: 10px;
            }
            .btn-default{
                width: 90px;
                height: 36px;
                line-height: 36px;
                background:#F68A01;
                border-radius: 20px;
                text-align: center;
                color: #fff;
                font-size:16px;
                margin-bottom: 10px;
            }
        }

        .content-forms {
            padding: 20px 40px;

            .save-btn {
                width: 90px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                color: #fff;
                background: #F68A01;
                border-radius: 20px;
                margin-left:20px;

            }
        }

        .chapter-form {
            /deep/ .el-form-item__label {
                color: #333 !important;
                font-size: 16px;
            }

            /deep/ .el-input__inner {
                border: none;
                // border-bottom: 1px solid #eee;
                color: #333 !important;
                height: 40px;
                background: #F5F5F5;
                border-radius: 4px;
                font-size: 18px;
                font-weight: 500;
            }

            /deep/ .el-textarea__inner {
                background: #FBFBFB;
                border: 1px solid #DDDDDD;
                min-height: 700px !important;
                padding: 20px;
                color: #333;
                line-height: 40px;
                border: none;
                font-size: 14px;
            }

            /*输入框*/
            /deep/.el-form-item.is-error .el-input__inner,
            /deep/.el-form-item.is-error .el-input__inner:focus,
            /deep/.el-form-item.is-error .el-textarea__inner,
            /deep/.el-form-item.is-error .el-textarea__inner:focus,
            /deep/.el-message-box__input input.invalid,
            /deep/.el-message-box__input input.invalid:focus {
                border-color: #F56C6C !important;
            }

            /deep/ .el-form {
                width: 100%;
                display: inline-block;
                margin-top: 20px;
            }

        }
    }
</style>
